import { render, staticRenderFns } from "./ErrorsBarChart.vue?vue&type=template&id=45c2f5fa&"
import script from "./ErrorsBarChart.vue?vue&type=script&lang=js&"
export * from "./ErrorsBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports